var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2087_13289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 2.33317V5.24984C8.16663 5.90317 8.38246 6.50984 8.74996 6.99984H5.24996C5.62913 6.49817 5.83329 5.8915 5.83329 5.24984V2.33317H8.16663ZM9.91663 1.1665H4.08329C3.76246 1.1665 3.49996 1.429 3.49996 1.74984C3.49996 2.07067 3.76246 2.33317 4.08329 2.33317H4.66663V5.24984C4.66663 6.21817 3.88496 6.99984 2.91663 6.99984V8.1665H6.39913V12.2498L6.98246 12.8332L7.56579 12.2498V8.1665H11.0833V6.99984C10.115 6.99984 9.33329 6.21817 9.33329 5.24984V2.33317H9.91663C10.2375 2.33317 10.5 2.07067 10.5 1.74984C10.5 1.429 10.2375 1.1665 9.91663 1.1665Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2087_13289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.a4d75ab7d09c751fb6039ad6cbc249f8.svg";
export { ForwardRef as ReactComponent };